<h1 mat-dialog-title i18n="Contest Certificate Modal|Certificate modal title@@contest-certificate-modal-title">
  Contest Certificates
</h1>
<div mat-dialog-content #dialogContent class="dialog-content">
  <permission-checker [roles]="roles" (contentInit)="initContent()">
    <item-select [roles]="roles"
                 label="Certificate type"
                 i18n-label="Contest Certificate Modal|Certificate type input label@@contest-certificate-modal-certificate-type-input-label"
                 [compareWith]="compareTypes"
                 [displayWith]="displayType"
                 [loadWith]="loadTypes"
                 [disabled]="inProgress || (!!type && editMode)"
                 (selected)="handleCertificateTypeChange($event)"></item-select>

    <form *ngIf="type && certificate" [formGroup]="optionsForm" (ngSubmit)="proceed()">
      <file-upload *ngIf="!certificate || !certificate.url"
                   acceptTypes=".png,.jpg,.jpeg,.gif"
                   fileTypes="*.png, *.jpg, *.gif"
                   (fileSelected)="onFileSelected($event)">
      </file-upload>
      <div *ngIf="certificate && certificate.url" class="certificate-image-holder">
        <app-button icon="delete"
                    [secondary]="true"
                    [destructive]="true"
                    [disabled]="!editMode"
                    class="delete-image-btn"
                    (clicked)="prevImage = certificate.url; certificate.url = undefined; $event.preventDefault();"></app-button>
        <img [src]="certificate.url" class="certificate-image" alt="certificate-image">
      </div>

      <mat-divider class="full-width"></mat-divider>

      <div class="center-align text-disabled-color mat-body-2"
           i18n="Contest Certificate Modal|Certificate primary text configuration title@@contest-certificate-modal-certificate-primary-text-configuration-title">
        Participant name text configuration:
      </div>

      <form-input [control]="fontSizeField"
                  type="number"
                  label="Font size"
                  i18n-label="Contest Certificate Modal|Contest Certificate Modal font size input label@@contest-certificate-modal-font-size-input-label"
                  placeholder="Font size..."
                  i18n-placeholder="Contest Certificate Modal|Contest Certificate Modal font size input placeholder@@contest-certificate-modal-font-size-input-placeholder"
                  [min]="1" [max]="150"></form-input>

      <div fxLayout="column" class="full-width">
        <div fxLayout="row" fxLayout.lt-sm="column">
          <div fxFlex="48%" fxFlex.lt-sm="100%">
            <form-input [control]="x1Field"
                        type="number"
                        label="Left X Coordinate"
                        i18n-label="Contest Certificate Modal|Contest Certificate Modal x1 input label@@contest-certificate-modal-x1-input-label"
                        placeholder="Left top X coordinate..."
                        i18n-placeholder="Contest Certificate Modal|Contest Certificate Modal x1 input placeholder@@contest-certificate-modal-x1-input-placeholder"
                        [min]="0"></form-input>
          </div>
          <div class="fill-space"></div>

          <div fxFlex="48%" fxFlex.lt-sm="100%">
            <form-input [control]="x2Field"
                        type="number"
                        label="Right X Coordinate"
                        i18n-label="Contest Certificate Modal|Contest Certificate Modal x2 input label@@contest-certificate-modal-x2-input-label"
                        placeholder="Right bottom X coordinate..."
                        i18n-placeholder="Contest Certificate Modal|Contest Certificate Modal x2 input placeholder@@contest-certificate-modal-x2-input-placeholder"
                        [min]="0"></form-input>
          </div>
        </div>

        <div fxLayout="row" fxLayout.lt-sm="column">
          <div fxFlex="48%" fxFlex.lt-sm="100%">
            <form-input [control]="y1Field"
                        type="number"
                        label="Left Y Coordinate"
                        i18n-label="Contest Certificate Modal|Contest Certificate Modal y1 input label@@contest-certificate-modal-y1-input-label"
                        placeholder="Left top Y coordinate..."
                        i18n-placeholder="Contest Certificate Modal|Contest Certificate Modal y1 input placeholder@@contest-certificate-modal-y1-input-placeholder"
                        [min]="0"></form-input>
          </div>
          <div class="fill-space"></div>

          <div fxFlex="48%" fxFlex.lt-sm="100%">
            <form-input [control]="y2Field"
                        type="number"
                        label="Right Y Coordinate"
                        i18n-label="Contest Certificate Modal|Contest Certificate Modal y2 input label@@contest-certificate-modal-y2-input-label"
                        placeholder="Right bottom Y coordinate..."
                        i18n-placeholder="Contest Certificate Modal|Contest Certificate Modal y2 input placeholder@@contest-certificate-modal-y2-input-placeholder"
                        [min]="0"></form-input>
          </div>
        </div>
      </div>

      <!--Secondary config -->

      <mat-divider class="full-width"></mat-divider>

      <div class="center-align text-disabled-color mat-body-2"
           i18n="Contest Certificate Modal|Certificate secondary text configuration title@@contest-certificate-modal-certificate-secondary-text-configuration-title">
        Teacher name text configuration:
      </div>

      <form-input [control]="secondaryFontSizeField"
                  [required]="false"
                  type="number"
                  label="Font size"
                  i18n-label="Contest Certificate Modal|Contest Certificate Modal font size input label@@contest-certificate-modal-font-size-input-label"
                  placeholder="Font size..."
                  i18n-placeholder="Contest Certificate Modal|Contest Certificate Modal font size input placeholder@@contest-certificate-modal-font-size-input-placeholder"
                  [min]="1" [max]="150"></form-input>

      <div fxLayout="column" class="full-width">
        <div fxLayout="row" fxLayout.lt-sm="column">
          <div fxFlex="48%" fxFlex.lt-sm="100%">
            <form-input [control]="secondaryX1Field"
                        [required]="false"
                        type="number"
                        label="Left X Coordinate"
                        i18n-label="Contest Certificate Modal|Contest Certificate Modal x1 input label@@contest-certificate-modal-x1-input-label"
                        placeholder="Left top X coordinate..."
                        i18n-placeholder="Contest Certificate Modal|Contest Certificate Modal x1 input placeholder@@contest-certificate-modal-x1-input-placeholder"
                        [min]="0"></form-input>
          </div>
          <div class="fill-space"></div>

          <div fxFlex="48%" fxFlex.lt-sm="100%">
            <form-input [control]="secondaryX2Field"
                        [required]="false"
                        type="number"
                        label="Right X Coordinate"
                        i18n-label="Contest Certificate Modal|Contest Certificate Modal x2 input label@@contest-certificate-modal-x2-input-label"
                        placeholder="Right bottom X coordinate..."
                        i18n-placeholder="Contest Certificate Modal|Contest Certificate Modal x2 input placeholder@@contest-certificate-modal-x2-input-placeholder"
                        [min]="0"></form-input>
          </div>
        </div>

        <div fxLayout="row" fxLayout.lt-sm="column">
          <div fxFlex="48%" fxFlex.lt-sm="100%">
            <form-input [control]="secondaryY1Field"
                        [required]="false"
                        type="number"
                        label="Left Y Coordinate"
                        i18n-label="Contest Certificate Modal|Contest Certificate Modal y1 input label@@contest-certificate-modal-y1-input-label"
                        placeholder="Left top Y coordinate..."
                        i18n-placeholder="Contest Certificate Modal|Contest Certificate Modal y1 input placeholder@@contest-certificate-modal-y1-input-placeholder"
                        [min]="0"></form-input>
          </div>
          <div class="fill-space"></div>

          <div fxFlex="48%" fxFlex.lt-sm="100%">
            <form-input [control]="secondaryY2Field"
                        [required]="false"
                        type="number"
                        label="Right Y Coordinate"
                        i18n-label="Contest Certificate Modal|Contest Certificate Modal y2 input label@@contest-certificate-modal-y2-input-label"
                        placeholder="Right bottom Y coordinate..."
                        i18n-placeholder="Contest Certificate Modal|Contest Certificate Modal y2 input placeholder@@contest-certificate-modal-y2-input-placeholder"
                        [min]="0"></form-input>
          </div>
        </div>
      </div>
    </form>


    <mat-divider *ngIf="certificate && certificate.url" class="full-width"></mat-divider>


    <form *ngIf="certificate" [formGroup]="testForm"
          (ngSubmit)="testCertificate()"
          class="right-align">

      <div class="center-align text-disabled-color mat-body-2"
           i18n="Contest Certificate Modal|Certificate test configuration title@@contest-certificate-modal-certificate-test-configuration-title">
        Test certificate configuration:
      </div>

      <form-input [control]="primaryTextField"
                  label="Participant name"
                  i18n-label="Contest Certificate Modal|Contest Certificate primary test text input label@@contest-certificate-modal-certificate-primary-test-text-input-label"
                  placeholder="Participant name..."
                  i18n-placeholder="Contest Certificate Modal|Contest Certificate primary test text input placeholder@@contest-certificate-modal-certificate-primary-test-text-input-placeholder"
                  [minLength]="1" [maxLength]="256"></form-input>

      <form-input [control]="secondaryTextField"
                  label="Teacher name"
                  i18n-label="Contest Certificate Modal|Contest Certificate secondary test text input label@@contest-certificate-modal-certificate-secondary-test-text-input-label"
                  placeholder="Teacher name..."
                  i18n-placeholder="Contest Certificate Modal|Contest Certificate secondary test text input placeholder@@contest-certificate-modal-certificate-secondary-test-text-input-placeholder"
                  [minLength]="1" [maxLength]="256"></form-input>

      <div class="test-block">
        <app-button *ngIf="!testCert" [disabled]="inProgress || !primaryTextField.valid || editMode"
                    (clicked)="testCertificate()"
                    label="Test"
                    i18n-label="General|Test action label@@general-test-action-label"></app-button>

        <app-button *ngIf="testCert && !editMode"
                    icon="delete"
                    [secondary]="true"
                    [destructive]="true"
                    (clicked)="testCert = undefined; $event.preventDefault();"></app-button>

        <app-link *ngIf="testCert && !editMode"
                  [external]="true"
                  [href]="testCert.url"
                  label="Certificate"
                  i18n-label="General|Contest certificate term@@general-contest-certificate-term"></app-link>
      </div>
    </form>
  </permission-checker>
</div>
<div mat-dialog-actions>
  <app-button *ngIf="certificate && !editMode && !createMode"
              [disabled]="inProgress"
              (clicked)="deleteCertificate(certificate)"
              [destructive]="true"
              label="Delete"
              i18n-label="General|Delete action label@@general-delete-action-label"></app-button>

  <div class="fill-space"></div>

  <app-button *ngIf="!editMode && !createMode"
              [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"
              label="Close"
              i18n-label="General|Close action label@@general-close-action-label"></app-button>
  <app-button *ngIf="editMode || createMode"
              [disabled]="inProgress"
              (clicked)="cancelEdit()"
              [secondary]="true"
              label="Cancel"
              i18n-label="General|Cancel action label@@general-cancel-action-label"></app-button>
  <span class="btn-spacer"></span>
  <app-button *ngIf="editMode"
              [disabled]="inProgress || !proceedAllowed()"
              (clicked)="proceed()"
              label="Save"
              i18n-label="General|Save action label@@general-save-action-label"></app-button>
  <app-button *ngIf="!editMode"
              [disabled]="inProgress"
              (clicked)="toggleEditMode(true)"
              label="Edit"
              i18n-label="General|Edit action label@@general-edit-action-label"></app-button>
</div>
